// extracted by mini-css-extract-plugin
export default {"footerStyle":"footer_footerStyle__DORnD","footerMsg":"footer_footerMsg__l8sXG"};